import { useEffect, useState, type FunctionComponent } from 'react';
import { ZoomCallEnd as SharedZoomCallEnd } from '@qler-view/shared_lib/src/shared/zoom';
import { useNavigate, useParams } from 'react-router-dom';
import { useUpdateConsultStatus } from '../../API/hooks/waitingHook';
import { CallStatusEnum } from '../../shared/CallStatusEnum';
import { Box } from '@mui/material';
import { CustomTypography } from '@qler-view/shared_lib/src';
import {
  CASEMANGER_CONSULT_REQUEST_DASHBOARD_ROUTE_PATH,
  FACILITY_CONSULT_REQUEST_DASHBOARD_ROUTE_PATH,
} from '../../routers/RoutPath';
import { ROLES } from '../../roles';
import { useAuth } from '../components/AuthContext';

const ZoomCallEnd: FunctionComponent = () => {
  const { caseId } = useParams<{ meetingId: string; caseId: string }>();
  const [isCompleted, setIsCompleted] = useState(false);
  const { user } = useAuth();
  const navigate = useNavigate();
  const { consultStatus, isLoading: isStatusLoading } = useUpdateConsultStatus(
    Number(caseId) || 0
  );

  useEffect(() => {
    if (isStatusLoading) return;

    if (consultStatus?.isParticipantLeftCall) {
      const dashboardPath =
        user?.role?.toString() === ROLES.CASE_MANAGER
          ? CASEMANGER_CONSULT_REQUEST_DASHBOARD_ROUTE_PATH
          : FACILITY_CONSULT_REQUEST_DASHBOARD_ROUTE_PATH;
      navigate(dashboardPath, {
        replace: true,
      });
    } else if (
      consultStatus?.status.toLowerCase() ===
      CallStatusEnum.CallCompleted.toLowerCase()
    ) {
      setIsCompleted(true);
    }
  }, [consultStatus, isStatusLoading, user?.role, navigate]);

  if (!isCompleted) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="200px"
      >
        <CustomTypography
          id="loading-text"
          variant="h5"
          className="text-align-center pt-32"
          color="textDisabled"
        >
          Zoom call is ending. Please wait...
        </CustomTypography>
      </Box>
    );
  }

  return <SharedZoomCallEnd />;
};

export default ZoomCallEnd;
